RivalIQ.module('apps', function (apps, App, Backbone, Marionette, $, _) {

    'use strict';

    const app = apps.Analyze = window.createMarionetteApp();
    app.name = 'Analyze';
});
